<div class="detail-container">
    <div class="fhd-border-group">
        <div class="header-row">
            <label class="label">{{"@controller" | translate}}:</label>
            <span class="value">{{assetFault.controllerDescription}}</span>
        </div>
        <div class="header-row">
            <label class="label">{{"@faultCode" | translate}}:</label>
            <span class="value">{{assetFault.faultCodeDescription}}</span>
        </div>
        <div class="header-row">
            <label class="label">{{"@failureMode" | translate}}:</label>
            <span class="value">{{assetFault.failureModeDescription}}</span>
        </div>
    </div>
    <form [formGroup]="faultDetailForm" class="fault-form">
        <mat-form-field class="padded-input">
            <mat-label>{{ '@enterDateRange' | translate }}</mat-label>
            <mat-date-range-input [rangePicker]="picker" [max]="maxDate">
                <input matStartDate placeholder="Start date" formControlName="dateFrom" name="dateFrom" disabled>
                <input matEndDate placeholder="End date" formControlName="dateTo" name="dateTo" disabled>
            </mat-date-range-input>
            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker disabled="false"></mat-date-range-picker>
        </mat-form-field>
    </form>
    <div *ngIf="loading" class="loading-strip">
        <mat-spinner [diameter]="40"></mat-spinner>
    </div>
    <app-orderable-list-view *ngIf="faultRowDefinition" (orderChanged)="null" (optionAction)="null" [data]="faults"
        [rowDefinition]="faultRowDefinition" [enableDragging]="false" [enableSelecting]="false" [menuOptions]="null"
        tableTitle="@history">
    </app-orderable-list-view>

    <div *ngIf="faults?.length <= 0 && !loading" class="centered-text add-margin-top-and-bottom">{{'@noFaults' | translate}}</div>

    <div class="fhd-button-group fhd-border-group">
        <button mat-raised-button (click)="onCloseClicked()">{{ '@close' | translate }}</button>
    </div>
</div>

<ng-template let-data="data" #dateDisplay>
    {{data | localizedDate: 'short'}}
</ng-template>